//Login.js
export const LOGIN_INVALID = "Login inválido!"